module.exports = __webpack_public_path__ + "img/handcuffs.eb59ff35.svg";